import React, { useEffect, useState } from "react";

// ─── CONFIG ───────────────────────────────────────────────────────────────────
// Change this to match what you set in checkin.php
const STAFF_KEY = "IBH_STAFF_SECRET_2026";
const CHECKIN_API = "https://myibh.in/api/checkin.php";
const AUTH_API = "https://myibh.in/api/verify-auth.php";
// Change this to match STAFF_PASSWORD in verify-auth.php
// (kept here only as a comment for reference — the real check happens server-side)
// ─────────────────────────────────────────────────────────────────────────────

const styles = `

  * { box-sizing: border-box; margin: 0; padding: 0; }

  .vt-page {
    font-family: 'Inter', sans-serif;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
  }
  .vt-page.idle    { background: #f0f2f5; }
  .vt-page.loading { background: #f0f2f5; }
  .vt-page.valid   { background: linear-gradient(135deg, #d4f5d4 0%, #b2f0b2 100%); }
  .vt-page.invalid { background: linear-gradient(135deg, #ffe0e0 0%, #ffc5c5 100%); }
  .vt-page.used    { background: linear-gradient(135deg, #fff8e0 0%, #ffe9a0 100%); }
  .vt-page.gate    { background: #f0f2f5; }

  .vt-card {
    background: #fff;
    border-radius: 28px;
    width: 100%;
    max-width: 420px;
    padding: 40px 36px;
    text-align: center;
    box-shadow: 0 12px 48px rgba(0,0,0,0.12);
  }

  .vt-logo {
    font-family: 'Poppins', sans-serif;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 2px;
    color: #9daac5;
    text-transform: uppercase;
    margin-bottom: 28px;
  }

  .vt-icon {
    width: 96px; height: 96px;
    border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    margin: 0 auto 22px;
    font-size: 44px;
  }
  .vt-icon.valid   { background: #e6ffe6; border: 3px solid #00a000; }
  .vt-icon.invalid { background: #ffe6e6; border: 3px solid #e53e3e; }
  .vt-icon.used    { background: #fff8e0; border: 3px solid #d4a000; }
  .vt-icon.loading { background: #f0f2f5; border: 3px solid #cbd5e1; }
  .vt-icon.idle    { background: #f0f2f5; border: 3px solid #e0e4ef; }
  .vt-icon.gate    { background: #fff5ec; border: 3px solid #f37c23; }

  .vt-status {
    font-family: 'Poppins', sans-serif;
    font-size: 1.5rem;
    font-weight: 800;
    margin-bottom: 8px;
  }
  .vt-status.valid   { color: #00a000; }
  .vt-status.invalid { color: #e53e3e; }
  .vt-status.used    { color: #b07d00; }
  .vt-status.loading { color: #9daac5; }
  .vt-status.idle    { color: #1a1f2e; }
  .vt-status.gate    { color: #0d1433; }

  .vt-name {
    font-family: 'Poppins', sans-serif;
    font-size: 1.25rem;
    font-weight: 700;
    color: #0d1433;
    margin-bottom: 4px;
  }
  .vt-ticket-id {
    display: inline-block;
    background: #fff5ec;
    border: 1.5px solid #f37c23;
    border-radius: 8px;
    padding: 5px 16px;
    font-family: 'Poppins', sans-serif;
    font-weight: 800;
    font-size: 0.95rem;
    color: #f37c23;
    margin: 10px 0;
    letter-spacing: 1px;
  }
  .vt-meta {
    font-size: 13px;
    color: #5b6577;
    line-height: 1.7;
    margin-top: 6px;
  }

  .vt-divider {
    height: 1px;
    background: #e0e4ef;
    margin: 22px 0;
  }

  .vt-error-msg {
    font-size: 14px;
    color: #5b6577;
    line-height: 1.6;
  }

  .vt-scan-again {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: #0d1433;
    color: #fff;
    font-family: 'Poppins', sans-serif;
    font-weight: 700;
    font-size: 0.9rem;
    padding: 12px 24px;
    border-radius: 50px;
    border: none;
    cursor: pointer;
    margin-top: 20px;
    text-decoration: none;
    transition: background 0.2s;
  }
  .vt-scan-again:hover { background: #1a2550; }

  /* Spinner */
  @keyframes spin { to { transform: rotate(360deg); } }
  .vt-spinner {
    width: 40px; height: 40px;
    border: 4px solid #e0e4ef;
    border-top-color: #f37c23;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    margin: 0 auto;
  }

  .vt-idle-hint {
    font-size: 13px;
    color: #9daac5;
    line-height: 1.6;
    margin-top: 12px;
  }
  .vt-footer-note {
    font-size: 11px;
    color: #c5cde0;
    margin-top: 28px;
    line-height: 1.5;
  }

  /* ── Staff gate ── */
  .vt-gate-hint {
    font-size: 13px;
    color: #5b6577;
    line-height: 1.6;
    margin-bottom: 22px;
  }
  .vt-gate-field {
    text-align: left;
    margin-bottom: 14px;
  }
  .vt-gate-field label {
    display: block;
    font-size: 12px;
    font-weight: 700;
    color: #5b6577;
    margin-bottom: 6px;
  }
  .vt-gate-field input {
    width: 100%;
    padding: 12px 14px;
    border: 1.5px solid #e0e4ef;
    border-radius: 10px;
    font-size: 14px;
    font-family: 'Inter', sans-serif;
    outline: none;
  }
  .vt-gate-field input:focus { border-color: #f37c23; }
  .vt-gate-error {
    color: #e53e3e;
    font-size: 13px;
    margin-bottom: 12px;
    text-align: left;
  }
  .vt-gate-submit {
    width: 100%;
    padding: 13px;
    background: #f37c23;
    color: #fff;
    border: none;
    border-radius: 10px;
    font-family: 'Poppins', sans-serif;
    font-weight: 700;
    font-size: 0.95rem;
    cursor: pointer;
    margin-top: 6px;
  }
  .vt-gate-submit:disabled { opacity: 0.6; cursor: default; }
`;

export default function VerifyTicket() {
  const [state, setState]   = useState("gate");    // gate | idle | loading | valid | invalid | used
  const [data, setData]     = useState(null);
  const [errorMsg, setErrorMsg] = useState("");

  // Staff gate state
  const [staffName, setStaffName] = useState("");
  const [password, setPassword]   = useState("");
  const [gateError, setGateError] = useState("");
  const [gateBusy, setGateBusy]   = useState(false);

  useEffect(() => {
    const savedAuthed = localStorage.getItem("ibh_staff_authed");
    const savedName   = localStorage.getItem("ibh_staff_name");

    if (savedAuthed === "true" && savedName) {
      setStaffName(savedName);
      proceedAfterAuth(savedName);
    } else {
      setState("gate");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const proceedAfterAuth = (name) => {
    const params = new URLSearchParams(window.location.search);
    const token  = params.get("token");
    if (!token) {
      setState("idle");
      return;
    }
    checkIn(token, name);
  };

  const handleGateSubmit = async (e) => {
    e.preventDefault();
    if (!staffName.trim()) {
      setGateError("Please enter your name.");
      return;
    }
    if (!password) {
      setGateError("Please enter the password.");
      return;
    }

    setGateBusy(true);
    setGateError("");

    try {
      const res  = await fetch(AUTH_API, {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ staff_name: staffName.trim(), password }),
      });
      const json = await res.json();

      if (json.success) {
        localStorage.setItem("ibh_staff_authed", "true");
        localStorage.setItem("ibh_staff_name", staffName.trim());
        proceedAfterAuth(staffName.trim());
      } else {
        setGateError(json.error || "Incorrect password.");
      }
    } catch {
      setGateError("Could not connect to server. Check your internet connection.");
    } finally {
      setGateBusy(false);
    }
  };

  const checkIn = async (token, name) => {
    setState("loading");
    setData(null);
    setErrorMsg("");

    try {
      const res  = await fetch(CHECKIN_API, {
        method:  "POST",
        headers: {
          "Content-Type": "application/json",
          "x-staff-key":  STAFF_KEY,
        },
        body: JSON.stringify({ token, staff_name: name }),
      });
      const json = await res.json();

      if (json.success) {
        setState("valid");
        setData(json);
      } else {
        // Differentiate "already checked in" from other errors
        if (json.error && json.error.toLowerCase().includes("already")) {
          setState("used");
        } else {
          setState("invalid");
        }
        setErrorMsg(json.error || "Invalid ticket.");
      }
    } catch {
      setState("invalid");
      setErrorMsg("Could not connect to server. Check your internet connection.");
    }
  };

  const iconMap = {
    idle:    "📲",
    loading: "",
    valid:   "✅",
    invalid: "❌",
    used:    "⚠️",
    gate:    "🔒",
  };

  const statusText = {
    idle:    "Waiting for QR Scan",
    loading: "Verifying…",
    valid:   "VALID TICKET",
    invalid: "INVALID TICKET",
    used:    "ALREADY CHECKED IN",
    gate:    "Staff Sign In",
  };

  return (
    <div className={`vt-page ${state}`}>
      <style>{styles}</style>

      <div className="vt-card">
        <div className="vt-logo">IBH · Freedom Conclave 2026 · Staff Portal</div>

        <div className={`vt-icon ${state}`}>
          {state === "loading"
            ? <div className="vt-spinner" />
            : iconMap[state]
          }
        </div>

        <div className={`vt-status ${state}`}>{statusText[state]}</div>

        {/* ── STAFF GATE ── */}
        {state === "gate" && (
          <>
            <p className="vt-gate-hint">
              Enter your name and the staff password to start scanning tickets.
            </p>
            <form onSubmit={handleGateSubmit}>
              {gateError && <div className="vt-gate-error">{gateError}</div>}
              <div className="vt-gate-field">
                <label>Your Name</label>
                <input
                  type="text"
                  value={staffName}
                  onChange={(e) => setStaffName(e.target.value)}
                  placeholder="e.g. Priya"
                  autoFocus
                />
              </div>
              <div className="vt-gate-field">
                <label>Staff Password</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                />
              </div>
              <button type="submit" className="vt-gate-submit" disabled={gateBusy}>
                {gateBusy ? "Checking…" : "Continue"}
              </button>
            </form>
          </>
        )}

        {/* ── VALID ── */}
        {state === "valid" && data && (
          <>
            <div className="vt-divider" />
            <div className="vt-name">{data.name}</div>
            <div className="vt-ticket-id">{data.ticket_id}</div>
            <div className="vt-meta">
              {data.organization && <>{data.organization}<br/></>}
              {data.city && <>{data.city}</>}
            </div>
          </>
        )}

        {/* ── ALREADY USED ── */}
        {state === "used" && (
          <>
            <div className="vt-divider" />
            <p className="vt-error-msg">{errorMsg}</p>
            <p className="vt-error-msg" style={{ marginTop: 8, fontSize: 12, color: "#b07d00" }}>
              This ticket was already scanned. Do not allow entry.
            </p>
          </>
        )}

        {/* ── INVALID ── */}
        {state === "invalid" && (
          <>
            <div className="vt-divider" />
            <p className="vt-error-msg">{errorMsg}</p>
            <p className="vt-error-msg" style={{ marginTop: 8, fontSize: 12, color: "#e53e3e" }}>
              This QR code is not recognised. Do not allow entry.
            </p>
          </>
        )}

        {/* ── IDLE ── */}
        {state === "idle" && (
          <p className="vt-idle-hint">
            Open your phone's camera or QR scanner app and scan an attendee's QR code.<br/><br/>
            The result will appear on this screen instantly.
          </p>
        )}

        {/* Scan again button for non-idle, non-loading, non-gate states */}
        {(state === "valid" || state === "invalid" || state === "used") && (
          <a href="/verify" className="vt-scan-again">
            <svg viewBox="0 0 24 24" fill="none" width="16" height="16">
              <path d="M3 7V3H7" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M21 7V3H17" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M3 17V21H7" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M21 17V21H17" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Scan Next Attendee
          </a>
        )}

        <div className="vt-footer-note">
          Staff only · myibh.in · Freedom Conclave 2026
        </div>
      </div>
    </div>
  );
}